<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-wait`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 3a1 1 0 011 1v2a1 1 0 01-1 1h-2v8c0 4.204-1.636 6.633-6.489 8.944C34.364 26.254 36 28.683 36 32.887V41h2a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2a1 1 0 011-1h2v-8.113c0-4.204 1.636-6.633 6.489-8.943C13.636 21.633 12 19.204 12 15V7h-2a1 1 0 01-1-1V4a1 1 0 011-1h28zM24 26.01l-.706.256c-5.94 2.188-7.245 3.526-7.293 6.45L16 41h16v-8.113l-.006-.337c-.098-2.92-1.571-4.24-7.994-6.54zM24 32l.63.206c4.454 1.48 5.37 2.386 5.37 4.417V39H18v-2.377c0-2.123 1.001-3.018 6-4.623zm8-25H16v8c0 3.159 1.335 4.49 8 6.878l.706-.256C30.76 19.39 32 18.044 32 15V7zm-14 7.377h12c0 2.123-1.001 3.018-6 4.623l-.63-.206c-4.252-1.412-5.28-2.303-5.364-4.147l-.006-.27h12-12z"/></svg>
</template>
<script>

export default {
  name: 'IconWait',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
